// extracted by mini-css-extract-plugin
module.exports = {"pageBlock":"page_pageBlock__8ZcX1","content":"page_content__lx2fe","rightColumn":"page_rightColumn__GuyG7","stickyBlock":"page_stickyBlock__Mcvk7"};